import { render } from "./FormFileHeader.vue?vue&type=template&id=5bafa41a&scoped=true"
import script from "./FormFileHeader.vue?vue&type=script&lang=js"
export * from "./FormFileHeader.vue?vue&type=script&lang=js"

import "./FormFileHeader.vue?vue&type=style&index=0&id=5bafa41a&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/osod-form/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bafa41a"]])

export default __exports__